import { useMutation } from '@tanstack/react-query';
import { exportTicketOutcomes } from '../requests/ticketOutcomeReport.request';
import { TicketOutcomeReportRequest } from '../types/ticketOutcomeReport.types';
import toast from 'react-hot-toast';
import { AxiosError } from 'axios';

export const useExportTicketOutcomesMutation = () => {
  return useMutation<void, AxiosError, TicketOutcomeReportRequest>({
    mutationKey: ['export-ticket-outcomes'],
    mutationFn: exportTicketOutcomes,
    onError: (error) => {
      toast.error(error.message || 'Failed to export ticket outcomes');
    },
    onSuccess: () => {
      toast.success('Report exported successfully');
    }
  });
};
